import { useAuth } from "@/contexts/AuthContext";
import { LogOut, AlertCircle } from "lucide-react";

/**
 * Sticky banner shown at the top of every page while an admin/staff member
 * is impersonating another user. Makes the override impossible to forget.
 */
export default function ImpersonationBanner() {
  const { isImpersonating, user, stopImpersonation } = useAuth();

  if (!isImpersonating) return null;

  const adminEmail = (typeof window !== "undefined" && localStorage.getItem("admin_email")) || "admin";

  const exit = async () => {
    await stopImpersonation();
    // Hard reload so every cached page-level fetch refreshes under the admin token.
    if (typeof window !== "undefined") window.location.href = "/dashboard";
  };

  return (
    <div className="sticky top-0 z-[60] bg-gradient-to-r from-[#EA580C] via-[#DC2626] to-[#9333EA] text-white shadow-[0_2px_20px_rgba(220,38,38,0.45)]" data-testid="impersonation-banner">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-wrap items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-2.5 min-w-0">
          <AlertCircle className="w-4 h-4 flex-shrink-0" />
          <p className="truncate">
            <strong>Admin Override</strong> · You are viewing as{" "}
            <strong>{user?.email || "user"}</strong>. Changes you make will affect this account.
            <span className="hidden sm:inline ml-1.5 opacity-80">(Logged in as {adminEmail})</span>
          </p>
        </div>
        <button
          onClick={exit}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/15 hover:bg-white/25 backdrop-blur text-white text-xs font-bold flex-shrink-0"
          data-testid="impersonation-exit-btn"
        >
          <LogOut className="w-3.5 h-3.5" /> Exit Impersonation
        </button>
      </div>
    </div>
  );
}
